import axiosRequest from "api";
import { payloadHelper } from "helpers/payload-helper";
import {
  DepositSubmissionFormType,
  DepositSubmissionResponseType,
  OnlineDepositSubmissionType,
  WithDrawalFormSettingTypeResponse,
  WithdrawalSubMissionType,
} from "types/deposit";

import {
  DepositFormSettingResponseType,
  MemberOrderPayload,
  MemberOrderResponseType,
  OnlineDepositResponseType,
} from "./type";

export const deposit = {
  async getDepositForm(username: string) {
    const response = await axiosRequest.post<DepositFormSettingResponseType>(
      "",
      payloadHelper("DepositForm", username, {
        username,
      })
    );
    return response.data;
  },
  async depositSubmission(
    username: string,
    payload: DepositSubmissionFormType
  ) {
    const response = await axiosRequest.post<DepositSubmissionResponseType>(
      "",
      payloadHelper("Deposit", username, payload)
    );
    return response.data;
  },
  async onlineDepositSubmoission(
    username: string,
    payload: OnlineDepositSubmissionType
  ) {
    const response = await axiosRequest.post<OnlineDepositResponseType>(
      "",
      payloadHelper("GatewayDeposit", username, payload)
    );
    return response.data;
  },
  async memberOrder(username: string, payload: MemberOrderPayload) {
    const response = await axiosRequest.post<MemberOrderResponseType>(
      "",
      payloadHelper("MemberOrder", username, payload)
    );
    return response.data;
  },
  async getWithdrawalForm(username: string) {
    const response = await axiosRequest.post<WithDrawalFormSettingTypeResponse>(
      "",
      payloadHelper("WithdrawForm", username, { username })
    );
    return response.data;
  },
  async withdrawalSubmission(
    username: string,
    payload: WithdrawalSubMissionType
  ) {
    const response = await axiosRequest.post<WithDrawalFormSettingTypeResponse>(
      "",
      payloadHelper("Withdrawal", username, payload)
    );

    return response.data;
  },
};
